import { Box, Table, TableRow, TopBar } from '@sam/components';
import { TableHeader, TableKey } from '@sam/components/src/Table/Table.types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { updateSchambeckUserTableConfig, useData } from 'shared';
import { convertUserFunctionsIntoTableEntries } from '../../utils/user/User.utils';
import { useUser } from '../../components/UserContext';
import { IconComponent, IconType } from '../../components/icons/IconComponent';

export const UserFunctionOverview: React.FC = () => {
  const { t } = useTranslation();
  const { axios, updateContextUser, user } = useUser();
  const navigate = useNavigate();
  const { data: allUserFunctions } = useData('USER_FUNCTION_ALL', {
    config: { fallbackData: [] },
  });

  /**
   * TableRows containing all customerFeedbackEntries
   */
  const rows: TableRow[] = useMemo(
    (): TableRow[] => convertUserFunctionsIntoTableEntries(allUserFunctions, navigate),
    [allUserFunctions, navigate],
  );
  return (
    <>
      <TopBar title={t('pages.userFunction.overview.topBarHeadline')}>
        <IconComponent type={IconType.ADD} onClick={() => navigate('edit')} />
      </TopBar>
      <Box>
        <Table
          tableConfig={user.tableConfig?.get(TableKey.USER_FUNCTION_OVERVIEW)}
          updateTableConfig={(updatedHeader) => {
            updateSchambeckUserTableConfig(
              axios,
              user,
              TableKey.USER_FUNCTION_OVERVIEW,
              updatedHeader,
            ).then((updatedUser) => updatedUser && updateContextUser(updatedUser));
          }}
          rows={rows}
          header={
            t('pages.customerFeedback.overview.tableHeader', {
              returnObjects: true,
            }) as TableHeader[]
          }
        />
      </Box>
    </>
  );
};
